import { createBrowserRouter } from "react-router-dom";

import { appMode } from "@/config/domains";
import { NotFoundPage } from "@/pages/errors/NotFoundPage";

import { churchRoutes } from "./routes/church";
import { marketingRoutes } from "./routes/marketing";
import { platformRoutes } from "./routes/platform";

const selectedRoutes = (() => {
  switch (appMode) {
    case "marketing":
      return marketingRoutes;

    case "platform":
      return platformRoutes;

    case "church":
    default:
      return churchRoutes;
  }
})();

export const router = createBrowserRouter([
  ...selectedRoutes,
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);